import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  CollectionReference,
  DocumentData,
  addDoc,
  query,
  orderBy,
} from '@angular/fire/firestore';
import { collectionData } from '@angular/fire/firestore';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentService {

  constructor(
    private firestore: Firestore,
    private storage: Storage
  ) {}

  getDocumentsByTenant(uid: string): Observable<any[]> {
    const docsRef = collection(
      this.firestore,
      `users/${uid}/documents`
    );

    const q = query(docsRef, orderBy('uploadedAt', 'desc'));

    return collectionData(q, { idField: 'id' });
  }

  /** Admin: upload document for tenant */
  async uploadDocumentForTenant(
    file: File,
    tenantUid: string,
    documentType: string,
    uploadedBy: string
  ) {
    const storageRef = ref(
      this.storage,
      `documents/${tenantUid}/${Date.now()}-${file.name}`
    );

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);

    const docsRef = collection(
      this.firestore,
      `users/${tenantUid}/documents`
    );

    return addDoc(docsRef, {
      documentType,
      documentUrl: url,
      status: 'pending',
      uploadedAt: new Date(),
      uploadedBy,
    });
  }
}
